import React from 'react'

const DateInput = React.forwardRef((props, ref) => (
  <div>
    <input 
      className='form-control' 
      placeholder='MM/DD/YYYY'
      ref={ref}
      autoComplete='off'
      value={props.value}
      onClick={props.onClick}
      onChange={props.onChange}
      name={props.name}
    />
  </div>
))

export default DateInput
